(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Destacado-carrusell-CA"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('sb-product-showcase')) {

    customElements.define(

      'sb-product-showcase',

      class SbProductShowcase extends HTMLElement {

        connectedCallback() {

          this.track = this.querySelector('[data-carousel-track]');

          this.previousButton = this.querySelector('[data-carousel-prev]');

          this.nextButton = this.querySelector('[data-carousel-next]');

          this.carouselMode = this.dataset.carouselMode || 'manual';

          this.autoplayInterval = Math.max(2000, Number(this.dataset.carouselInterval) || 4000);
          this.countdown = this.querySelector('[data-countdown]');

          if (this.countdown) {
            const countdownEnd = new Date(this.countdown.dataset.countdownEnd).getTime();

            const updateCountdown = () => {
              const distance = countdownEnd - Date.now();

              if (!Number.isFinite(countdownEnd) || distance <= 0) {
                this.countdown.hidden = true;
                if (this.countdownTimer) window.clearInterval(this.countdownTimer);
                return;
              }

              const pad = (value) => String(value).padStart(2, '0');
              this.countdown.querySelector('[data-countdown-days]').textContent = pad(Math.floor(distance / 86400000));
              this.countdown.querySelector('[data-countdown-hours]').textContent = pad(Math.floor((distance % 86400000) / 3600000));
              this.countdown.querySelector('[data-countdown-minutes]').textContent = pad(Math.floor((distance % 3600000) / 60000));
              this.countdown.querySelector('[data-countdown-seconds]').textContent = pad(Math.floor((distance % 60000) / 1000));
            };

            updateCountdown();
            if (!this.countdown.hidden) this.countdownTimer = window.setInterval(updateCountdown, 1000);
          }





          if (!this.track || !this.previousButton || !this.nextButton) return;





          this.handleScroll = this.updateControls.bind(this);

          this.handlePrevious = () => this.move(-1);

          this.handleNext = () => this.move(1);

          this.handlePointerDown = () => this.stopAutoplay();

          this.handlePointerUp = () => this.startAutoplay();

          this.handleFocusIn = () => this.stopAutoplay();

          this.handleFocusOut = () => this.startAutoplay();

          this.handleVisibility = () => {

            if (document.hidden) {

              this.stopAutoplay();

            } else {

              this.startAutoplay();

            }

          };





          this.previousButton.addEventListener('click', this.handlePrevious);

          this.nextButton.addEventListener('click', this.handleNext);

          this.track.addEventListener('scroll', this.handleScroll, { passive: true });

          this.track.addEventListener('pointerdown', this.handlePointerDown, { passive: true });

          this.track.addEventListener('pointerup', this.handlePointerUp, { passive: true });

          this.track.addEventListener('pointercancel', this.handlePointerUp, { passive: true });

          this.addEventListener('focusin', this.handleFocusIn);

          this.addEventListener('focusout', this.handleFocusOut);

          document.addEventListener('visibilitychange', this.handleVisibility);





          if ('ResizeObserver' in window) {

            this.resizeObserver = new ResizeObserver(this.handleScroll);

            this.resizeObserver.observe(this.track);

          }





          this.updateControls();

          this.startAutoplay();

        }





        disconnectedCallback() {

          if (this.countdownTimer) window.clearInterval(this.countdownTimer);
          if (!this.track) return;

          this.previousButton?.removeEventListener('click', this.handlePrevious);

          this.nextButton?.removeEventListener('click', this.handleNext);

          this.track.removeEventListener('scroll', this.handleScroll);

          this.track.removeEventListener('pointerdown', this.handlePointerDown);

          this.track.removeEventListener('pointerup', this.handlePointerUp);

          this.track.removeEventListener('pointercancel', this.handlePointerUp);

          this.removeEventListener('focusin', this.handleFocusIn);

          this.removeEventListener('focusout', this.handleFocusOut);

          document.removeEventListener('visibilitychange', this.handleVisibility);

          this.resizeObserver?.disconnect();

          this.stopAutoplay();

        }





        startAutoplay() {

          if (this.carouselMode !== 'automatic') return;

          if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;





          this.stopAutoplay();

          this.autoplayTimer = window.setInterval(() => this.advance(), this.autoplayInterval);

        }





        stopAutoplay() {

          if (!this.autoplayTimer) return;

          window.clearInterval(this.autoplayTimer);

          this.autoplayTimer = null;

        }





        advance() {

          const maximumScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);

          const currentScroll = Math.abs(this.track.scrollLeft);





          if (currentScroll >= maximumScroll - 2) {

            this.track.scrollTo({ left: 0, behavior: 'smooth' });

          } else {

            this.move(1);

          }

        }





        move(direction) {

          const card = this.track.querySelector('.sb-product-showcase__card');

          if (!card) return;





          const styles = window.getComputedStyle(this.track);

          const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;

          const distance = card.getBoundingClientRect().width + gap;





          this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });

        }





        updateControls() {

          const maximumScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);

          const currentScroll = Math.abs(this.track.scrollLeft);

          const isScrollable = maximumScroll > 2;





          this.toggleAttribute('data-not-scrollable', !isScrollable);

          this.previousButton.disabled = !isScrollable || currentScroll <= 2;

          this.nextButton.disabled = !isScrollable || currentScroll >= maximumScroll - 2;

        }

      }

    );

  }


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-por-necesidad"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('tpn-tabs')) return;
    class TpnTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        var self = this;
        this.tabs.forEach(function (tab, i) {
          tab.addEventListener('click', function () { self.select(i); });
          tab.addEventListener('keydown', function (e) { self.onKey(e, i); });
        });
      }
      onKey(e, i) {
        var last = this.tabs.length - 1;
        var next = null;
        if (e.key === 'ArrowRight') next = i === last ? 0 : i + 1;
        else if (e.key === 'ArrowLeft') next = i === 0 ? last : i - 1;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = last;
        if (next === null) return;
        e.preventDefault();
        this.select(next, true);
      }
      select(i, focus) {
        this.tabs.forEach(function (t, j) {
          var on = j === i;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        this.panels.forEach(function (p, j) { p.hidden = j !== i; });
        var tab = this.tabs[i];
        if (!tab) return;
        if (focus) tab.focus({ preventScroll: true });
        var strip = tab.parentElement;
        if (strip.scrollWidth > strip.clientWidth) {
          var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          strip.scrollTo({
            left: tab.offsetLeft - (strip.clientWidth - tab.offsetWidth) / 2,
            behavior: reduce ? 'auto' : 'smooth'
          });
        }
      }
    }
    customElements.define('tpn-tabs', TpnTabs);
    document.addEventListener('shopify:block:select', function (e) {
      var tab = document.getElementById('tpn-tab-' + e.detail.blockId);
      if (!tab) return;
      var host = tab.closest('tpn-tabs');
      if (host && host.tabs) host.select(host.tabs.indexOf(tab));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
